// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1QEvN","itemTitle":"ClientEmergencyInfo_itemTitle__20rHl","itemText":"ClientEmergencyInfo_itemText__RZZy1"};